import { Link } from 'gatsby';
import { EuiSpacer } from '@elastic/eui';
import DDNSCards from 'components/Internet_Access/DDNS_Provider/DDNSCards';
import NavButtons from 'components/Internet_Access/NavButtons';
import ForumBox from 'components/Internet_Access/DDNS_Provider/PrimaryBox';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  EuiSpacer,
  DDNSCards,
  NavButtons,
  ForumBox,
  BreadCrumbs,
  SEOHelmet,
  React
};